const cardConstants = {
  CART_ADD_ITEM: 'CART_ADD_ITEM',
  CART_REMOVE_ITEM: 'CART_REMOVE_ITEM',
  CART_SHIPPING_ADDRESS: 'CART_SHIPPING_ADDRESS',
  CART_PAYMENT_METHOD: 'CART_PAYMENT_METHOD',
  CART_CLEAR_ALL: 'CART_CLEAR_ALL',
};

export default cardConstants;
